module.exports = __webpack_public_path__ + "img/right-icon.5f85e6be.svg";